module.exports = __webpack_public_path__ + "assets/images/project/constituencies/marine-parade-grc.jpg?v=7d3b8baa";